import React, {useEffect} from 'react';
import {QueryStatus} from '@reduxjs/toolkit/query/react';
import {useNavigate} from 'react-router';
import type {NoProps} from 'types';
import {useLocalization} from 'localization';
import {useGetTasksQuery} from 'services/tasks';
import {queryStatusToLoadStatus} from 'store/api';
import {Scene} from 'components/scene';

type Props = NoProps;

export const SearchMetadataScene: React.FC<Props> = () => {
  const navigate = useNavigate();
  const {t} = useLocalization();

  const {data, status} = useGetTasksQuery();

  useEffect(() => {
    if (status === QueryStatus.fulfilled) {
      navigate(`/metadata/${data?.[0].metadata.workId}`);
    }
  }, [data, navigate, status]);

  return (
    <Scene browserTitle={t('appbar.searchMetadata')}>
      <Scene.Header title={t('appbar.searchMetadata')} />
      <Scene.Content
        loadStatus={queryStatusToLoadStatus(status)}
        loadingType={t('general.entity.tasks')}
      />
    </Scene>
  );
};
